import { useLocation } from "react-router-dom";

import { Box, Button, Typography } from "@braintrust/braintrust-ui-components";
import { useMediaQuery } from "@braintrust/braintrust-ui-components";
import { ArrowRightTopIcon } from "@braintrust/braintrust-ui-components/Icons";
import { RouterLink } from "@js/components/link";

import style from "./styles.module.scss";

export const PublicJobsListingHeader = () => {
  const isMobile = useMediaQuery("sm");
  const { search } = useLocation();

  return (
    <Box sx={{ mb: 4.5 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant="title"
          component="h1"
          size={isMobile ? "medium" : "large"}
          fontWeight={400}
        >
          Braintrust finds jobs that work for you
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 2.5,
          textAlign: "center",
        }}
      >
        <Typography
          variant={isMobile ? "label" : "title"}
          component="h2"
          size={isMobile ? "large" : "small"}
          fontWeight={400}
          sx={{ maxWidth: "80%" }}
        >
          Create a free profile to access hundreds of jobs. All communication,
          scheduling, and payments happen here — don’t miss your next step.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="positive"
          to={`/auth/sign_up${search}`}
          RouterLink={RouterLink}
        >
          <Typography
            variant="paragraph"
            component="span"
            size="medium"
            fontWeight={500}
          >
            Sign up
          </Typography>
          <ArrowRightTopIcon className={style.signUpButtonIcon} />
        </Button>
      </Box>
    </Box>
  );
};
